import { queryClient } from 'common/repositories/query-client';
import { CredentialCookieStorage } from 'components/common/credential-cookie-storage';

import clearStorage from './storage';

export default async function logout() {
  CredentialCookieStorage.remove();
  clearStorage();
  await queryClient.invalidateQueries();
}
